<template>
    <PopupRouterViewDetail label="Work Order Process Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Work Order Process" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Work Order Process Number" :model="model.workOrderProcessNumber" />
						<app-input-datepicker :isEditable="false"  id="fieldset-production-date" label-cols-lg="12"  label="Production Date" size="sm" :model.sync="model.productionDate" :isRequired="true" :state="validateState('productionDate')" :errorMessage="getErrorMessage(errorMessage.productionDate, 'productionDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" />
						<app-input-combobox-autocomplete :isEditable="false" :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line Code" id="fieldset-line-code" size="sm" :model.sync="model.lineCodeId" :isRequired="true" :state="validateState('lineCodeId')" :errorMessage="getErrorMessage(errorMessage.lineCodeId, 'lineCodeId')"   :selected="model.lineCode != null ? model.lineCode.code : ''" @input="getLines" @change="updateData"  :isUpdatable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedLineCode" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :isEditable="false" :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Process Type" id="fieldset-process-type" size="sm" :model.sync="model.processTypeId" :isRequired="true" :state="validateState('processTypeId')" :errorMessage="getErrorMessage(errorMessage.processTypeId, 'processTypeId')"   :selected="model.processType != null ? model.processType.code : ''" @input="getProcessTypes" @change="onProcessTypeChange"  :isUpdatable="false"  />
						<app-label label-cols-lg="12" size="sm" label="Process Type" :model="model.processType!=null ? model.processType.name:null" />
						<app-input-combobox-autocomplete :isEditable="false" :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @change="updateData"  :isUpdatable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
						<app-label label-cols-lg="12" size="sm" label="Remarks" :model="model.remarks" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Work Order Process Detail" :bordered="true" :items="workOrderProcessDetails" :fields="fieldsWorkOrderProcessDetail" :busy="isDataLoading" :sort-by.sync="sortByWorkOrderProcessDetail" :sort-desc.sync="sortDescWorkOrderProcessDetail" small responsive
			@editButtonMethod="editRowDataWorkOrderProcessDetail"
			@deleteButtonMethod="deleteRowDataWorkOrderProcessDetail"
			@showPopupAddMethod="resetDataWorkOrderProcessDetail()"
			@showPopupUploadMethod="showPopupUploadWorkOrderProcessDetail()"
			@downloadMethod="downloadWorkOrderProcessDetail()"
			@addFromClipboardMethod="addFromClipboardWorkOrderProcessDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardWorkOrderProcessDetail()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadWorkOrderProcessDetail"
			>
			<template #top-row v-if="isShowWorkOrderProcessDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterWorkOrderProcessDetail.partId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Bill Of Process">
					<v-select append-to-body label="partNumber" :options="billOfProcesss"  :value="filterWorkOrderProcessDetail.billOfProcessId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.billOfProcessId" @search="getBillOfProcesss" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Line Machine">
					<v-select append-to-body label="code" :options="machines"  :value="filterWorkOrderProcessDetail.machineId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.machineId" @search="getMachines" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty (Plan)">
					<b-form-input id="input-qty-plan-table" v-model="filterWorkOrderProcessDetail.qtyPlan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Hour (Plan)">
					<b-form-input id="input-hour-plan-table" v-model="filterWorkOrderProcessDetail.hourPlan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-remark-table" v-model="filterWorkOrderProcessDetail.remark" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( workOrderProcessDetailPageSize * (currentWorkOrderProcessDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(printAction)="row">
				<b-dropdown text="Action" class="m-md-2 btn-action-more position-static">
					<b-dropdown-item @click="printPdfCustom(row.item)"><b-icon-printer></b-icon-printer> Print WO Process</b-dropdown-item>
					<b-dropdown-item @click="printPcc(row.item)"><b-icon-printer></b-icon-printer> Print PCC</b-dropdown-item>
					<b-dropdown-item @click="printPccAdditional(row.item)" :class="{ 'disabled-item': !row.item.isPrintLabel }" :disabled="!row.item.isPrintLabel"><b-icon-printer></b-icon-printer> Print PCC Additional</b-dropdown-item>
					<b-dropdown-item @click="printPccPending(row.item)"><b-icon-printer></b-icon-printer> Print Pending Card</b-dropdown-item>
					<b-dropdown-item @click="printPccNg(row.item)"><b-icon-printer></b-icon-printer> Print NG Card</b-dropdown-item>
					<b-dropdown-item v-if="row.item.documentStatusId == 'OPEN'" @click="$bvModal.show('modal-force-close-' + row.item.id)"><b-icon-exclamation-circle></b-icon-exclamation-circle> Close Work Order</b-dropdown-item>
				</b-dropdown>
				<b-modal class="modal-close" :id="'modal-force-close-' + row.item.id" title="Close Work Order" @show="resetCloseModal(row.item)" @hidden="resetCloseModal(row.item)" @ok="forceClose(row.item)">
					<app-input-textbox :id="'input-work-order-process-remarks-' + row.item.id" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remark" />
				</b-modal>
				<!-- <div class="two-item">
					<b-button @click="printPdfCustom(row.item.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print WO Process</b-button>
				</div>
				<div class="two-item">
					<b-button @click="printPcc(row.item.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print PCC</b-button>
					<b-button @click="printPccAdditional(row.item.id)" :disabled="!row.item.isPrintLabel" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print Additional PCC</b-button>
				</div>
				<div class="two-item">
					<b-button @click="printPccPending(row.item.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print Pending Card</b-button>
					<b-button @click="printPccNg(row.item.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer>Print Ng Card</b-button>
				</div> -->
			</template>
			<template v-slot:cell(lotNo)="row">
				<div class="two-item">
					<span>
						{{ row.item.lotNo }}
					</span>
				</div>
			</template>
			<template v-slot:cell(part)="row">
				<div class="two-item">
					<span>
						{{ (row.item.part != null) ? row.item.part.partNumber : "" }}
					</span>
				</div>
				<!-- <app-label label="Part Number" size="sm" :model="(row.item.part != null) ? row.item.part.partNumber : null"/> -->
			</template>
			<template v-slot:cell(partName)="row">
				<div class="two-item">
					<span>
						{{ (row.item.part != null) ? row.item.part.partName : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  /> -->
			</template>
			<template v-slot:cell(partClassification)="row">
				<div class="two-item">
					<span>
						{{ (row.item.part != null) ? row.item.part.partClassification != null ? row.item.part.partClassification.name : "" : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(row.item.part != null) ? (row.item.part.partClassification != null) ? row.item.part.partClassification.code : null : null"  /> -->
			</template>
			<template v-slot:cell(standarPackagingQty)="row">
				<div class="two-item">
					<span>
						{{ (row.item.part != null) ? row.item.part.standarPackagingQty : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" size="sm" label="Standard Packaging Qty" :model="(row.item.part != null) ? row.item.part.standarPackagingQty : null"  /> -->
			</template>
			<template v-slot:cell(nextProcess)="row">
				<div class="two-item">
					<span>
						{{ (row.item.billOfProcess != null) ? row.item.billOfProcess.nextProcess != null ? row.item.billOfProcess.nextProcess.name : "" : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" size="sm" label="NextProcess" :model="(row.item.billOfProcess != null) ? (row.item.billOfProcess.nextProcess != null) ? row.item.billOfProcess.nextProcess.name : null : null"  /> -->
			</template>
			<template v-slot:cell(machine)="row">
				<div class="two-item">
					<span>
						{{ (row.item.machine != null) ? row.item.machine.name : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" label="Line Machine" size="sm" :model="(row.item.machine) != null ? row.item.machine.code : ''" /> -->
			</template>
			<template v-slot:cell(sph)="row">
				<div class="two-item">
					<span>
						{{ (row.item.machine != null) ? row.item.machine.sph : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" size="sm" label="Stroke Per Hour" :model="(row.item.machine != null) ? row.item.machine.sph : null"  /> -->
			</template>
			<template v-slot:cell(qtyPlan)="row">
				<app-input-textbox :id="'input-work-order-process-detail-qty-plan-' + row.index" label-cols-lg="12" label="Qty (Plan)" size="sm" :model.sync="row.item.qtyPlan" :state="validateState('qtyPlan')" :errorMessage="getErrorMessage(errorMessage.qtyPlan, 'qtyPlan')"   @change="saveInputWorkOrderProcessDetail(row.item)"  :isUpdatable="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(hourPlan)="row">
				<app-input-textbox :isEditable="false" :id="'input-work-order-process-detail-hour-plan-' + row.index" label-cols-lg="12" label="Hour (Plan)" size="sm" :model.sync="row.item.hourPlan"   @change="saveInputWorkOrderProcessDetail(row.item)"  :isUpdatable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(customer)="row">
				<div class="two-item">
					<span>
						{{ (row.item.part != null) ? row.item.part.customer != null ? row.item.part.customer.name : "" : "" }}
					</span>
				</div>
				<!-- <app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  /> -->
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :isEditable="false" :id="'input-work-order-process-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputWorkOrderProcessDetail(row.item)"  :isUpdatable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(documentStatus)="row">
				<div class="two-item">
					<span>{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} </span>
					<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
				</div>
			</template>

			<template v-slot:form-add-detail>
				<WorkOrderProcessDetailInput 
					:openPopup="isShowPopupWorkOrderProcessDetail"
					:modelId="workOrderProcessDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataWorkOrderProcessDetail"/>
			</template>
			<template v-slot:upload-detail>
				<WorkOrderProcessDetailUpload
					:openPopup="isShowPopupUploadWorkOrderProcessDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataWorkOrderProcessDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
					<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(row.item.part != null) ? (row.item.part.partClassification != null) ? row.item.part.partClassification.code : null : null"  />
					<app-label label-cols-lg="12" size="sm" label="Standard Packaging Qty" :model="(row.item.part != null) ? row.item.part.standarPackagingQty : null"  />
					<app-input-combobox-autocomplete :options="billOfProcesss" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-process-detail-bill-of-process-' + row.index" label-cols-lg="12" label="Bill Of Process" size="sm" :model.sync="row.item.billOfProcessId"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.billOfProcess != null ? row.item.billOfProcess.partNumber : ''"  @input="getBillOfProcesss" :loading="isBillOfProcessComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-label label-cols-lg="12" size="sm" label="NextProcess" :model="(row.item.billOfProcess != null) ? (row.item.billOfProcess.nextProcess != null) ? row.item.billOfProcess.nextProcess.name : null : null"  />
					<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" :id="'input-work-order-process-detail-machine-' + row.index" label-cols-lg="12" label="Line Machine" size="sm" :model.sync="row.item.machineId" :state="validateState('machineId')" :errorMessage="getErrorMessage(errorMessage.machineId, 'machineId')"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.machine != null ? row.item.machine.code : ''"  @input="getMachines" :loading="isMachineComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-label label-cols-lg="12" size="sm" label="Stroke Per Hour" :model="(row.item.machine != null) ? row.item.machine.sph : null"  />
					<app-input-textbox :id="'input-work-order-process-detail-qty-plan-' + row.index" label-cols-lg="12" label="Qty (Plan)" size="sm" :model.sync="row.item.qtyPlan" :state="validateState('qtyPlan')" :errorMessage="getErrorMessage(errorMessage.qtyPlan, 'qtyPlan')"   @change="saveInputWorkOrderProcessDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-work-order-process-detail-hour-plan-' + row.index" label-cols-lg="12" label="Hour (Plan)" size="sm" :model.sync="row.item.hourPlan"   @change="saveInputWorkOrderProcessDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  />
					<app-input-textarea :id="'input-work-order-process-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputWorkOrderProcessDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

		<PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Print WO Process" />
		<PopupPDF :openPopup="isShowPopUpPdfList" :pdfUrl="pdfUrlList" @resetModalMethod="resetModal" label="Print WO List" />

        <b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-left-button>
			<div>
				<b-button v-if="false" @click="$bvModal.show('madal-force-close')" class="ml-2 mt-2 mt-sm-0 btn-outline-danger" size="sm"><b-icon-exclamation-circle></b-icon-exclamation-circle> Close Work Order</b-button>
				<b-button @click="printWoList(model.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print WO List</b-button>
				<b-button @click="printPdfCustom('all')" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print WO Process</b-button>
			</div>
		</template>

		<b-modal v-if="false" class="modal-close" id="madal-force-close" title="Close Work Order" @show="resetCloseModal" @hidden="resetCloseModal" @ok="forceClose">
			<app-input-textbox id="input-work-order-process-remarks" label-cols-lg="12" label="Remarks" size="sm" :model.sync="remarks" />
		</b-modal>

    </PopupRouterViewDetail>
</template>
<style scoped>
	.modal-close {
		max-width: 500px !important;
		max-height: 200px !important;
	}
	.two-item {
		display: flex;
		padding: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		width: 30px;
		height: 30px;
	}
	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}

	.btn-action-more .dropdown-item.disabled {
		color: #868e96 !important; /* Custom color for disabled item */
		cursor: not-allowed;
	}

	.disabled-item {
		color: #868e96 !important; /* Custom color for disabled item */
		cursor: not-allowed; /* Change cursor to indicate not clickable */
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import moment from 'moment';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderProcessDetailInput from '@/views/WorkOrderProcess/WorkOrderProcessDetailInput';
import WorkOrderProcessDetailUpload from '@/views/WorkOrderProcess/WorkOrderProcessDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
export default {
	components : {
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		WorkOrderProcessDetailInput,WorkOrderProcessDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF
	},
	mixins : [validationMixin],
	validations: {
		model: {
			productionDate: {required},
			lineCodeId: {required},
			processTypeId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				productionDate: { required : "Production Date is Required."},
				lineCodeId: { required : "Line Code is Required."},
				processTypeId: { required : "Process Type is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsWorkOrderProcessDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"printAction" : { "class" : "th-print-action d-stack-none"}},
				{"lotNo" : {"class" : "th-lotNo first-child", "label" : "Lot Number", key : 'lotNo', sortable: false}},
				{"part": { "class" : "th-part d-stack-none", "label" : "Part Number", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"partClassification": { "class" : "th-part-classification last-child", "label" : "Part Classification", key: 'partClassification', sortable: false}}, 
				{"standarPackagingQty": { "class" : "th-standar-packaging-qty d-stack-none", "label" : "Standard Packaging Qty", key: 'standarPackagingQty', sortable: false}}, 
				{"nextProcess": { "class" : "th-next-process d-stack-none", "label" : "NextProcess", key: 'nextProcess', sortable: false}}, 
				{"machine": { "class" : "th-machine d-stack-none", "label" : "Line Machine", key: 'machine', sortable: false}}, 
				{"sph": { "class" : "th-sph d-stack-none", "label" : "Stroke Per Hour", key: 'sph', sortable: false}}, 
				{"qtyPlan": { "class" : "th-qty-plan d-stack-none", "label" : "Qty (Plan)", key: 'qtyPlan', sortable: false}}, 
				{"hourPlan": { "class" : "th-hour-plan d-stack-none", "label" : "Hour (Plan)", key: 'hourPlan', sortable: false}}, 
				{"customer": { "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelWorkOrderProcessDetail : {},
			isShowPopupWorkOrderProcessDetail : false,
			isShowPopupUploadWorkOrderProcessDetail : false,
			filterWorkOrderProcess : null,
			currentWorkOrderProcessPage : 1,
			workOrderProcessPageSize: 10,
			sortByWorkOrderProcess: '',
			sortDescWorkOrderProcess: '',
			filterWorkOrderProcessDetail : null,
			currentWorkOrderProcessDetailPage : 1,
			workOrderProcessDetailPageSize: 10,
			sortByWorkOrderProcessDetail: '',
			sortDescWorkOrderProcessDetail: '',
			sortingByWorkOrderProcessDetail: [],
			workOrderProcessDetails : [],
			workOrderProcessDetailId : '',
			totalWorkOrderProcessDetailRow : 0,
			isShowWorkOrderProcessDetailFilter: false,
			isDownloadWorkOrderProcessDetail: false,
			parts: [],
			documentStatuss: [],
			billOfProcesss: [],
			machines: [],
			lines: [],
			lineCodes: [],
			isLineCodeComboLoading: false,
			processTypes: [],
			isProcessTypeComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isLineComboLoading: false,
			isDocumentStatusComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isPartComboLoading: false,
			isBillOfProcessComboLoading: false,
			isMachineComboLoading: false,
			isShowPopUpPdf: false,
			pdfUrl: '',
			isShowPopUpPdfList: false,
			pdfUrlList: '',
			remarks: '',
		}
	},
	methods : {
		resetCloseModal(item) {
			item.remark = '';
		},
		async forceClose(item) {
			try {
				this.isBusy = true;
				const response = await this.$http.post(`workorderprocess/forcecloseworkorderdetail/${item.id}`, item.remark, {
					header: {
						'Content-Type': 'text/plain'
					}
				});
				if(response && response.data) {
					this.resetCloseModal(item);
					this.$bvModal.hide('modal-force-close-' + item.id);
					await this.getWorkOrderProcess(this.modelId);
					await this.getWorkOrderProcessDetails(false);	
				}
				this.isBusy = false;
			} catch(error) {
				this.isBusy = false;
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		getRectangleClass(documentStatus) {
			let cls = "rectangle";
			if(documentStatus == "CLOSED") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}

			return cls;
		},
		printWoList: async function(id) {
			try {
				this.isBusy = true;
				let data = parseInt(id);
				if(!isNaN(data)) {
					let result = await WorkOrderProcess.printWoList(this, data, this.model.workOrderProcessNumber);
					if(result) {
						this.isShowPopUpPdfList = true;
						this.pdfUrlList = result.download;
					}
					this.isBusy = false;
				}
			} catch(error) {
				this.isShowPopUpPdfList = false;
				this.pdfUrlList = '';
				this.isBusy = false;
			}
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		printPcc: async function(item) {
			try {
				if(item.isPrintLabel) {
					let message = `<b>PCC</b> sudah pernah di print pada tanggal <b>${moment(item.printDate).format("DD-MMM-YYYY")}</b> oleh <b>${item.printBy}</b>, apakah yakin untuk print ulang?`;
					if(!await this.showPopupWithMessage(message)) return;
				}

				let data = parseInt(item.id);
				console.log("data", data);
				if(!isNaN(data)) {
					const response = await WorkOrderProcessDetail.printPCC(this, data);
					console.log("result", response);
					if(response) {
						
						this.$bvToast.toast("Succeed Printing to ZPL Printer", {
							title: 'Print PCC',
							variant: 'success',
							solid: true,
							autoHideDelay: 3000 // Optional: Mengatur durasi pesan
						});

						await this.getWorkOrderProcess(this.model.id);
					}
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		printPccAdditional: async function(item) {
			try {
				let data = parseInt(item.id);
				if(!isNaN(data)) {
					await WorkOrderProcessDetail.printPCCAdditional(this, data).then(result => {
						if(result.result == "OK") {
							this.$bvToast.toast("Succeed Printing to ZPL Printer", {
								title: 'Print PCC Additional',
								variant: 'success',
								solid: true,
								autoHideDelay: 3000 // Optional: Mengatur durasi pesan
							});
						}
					});
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		printPccPending: async function(item) {
			try {

				if(item.printPendingBy) {
					let message = `<b>PCC Pending</b> sudah pernah di print pada tanggal <b>${moment(item.printPendingDate).format("DD-MMM-YYYY")}</b> oleh <b>${item.printPendingBy}</b>, apakah yakin untuk print ulang?`;
					if(!await this.showPopupWithMessage(message)) return;
				}

				let data = parseInt(item.id);
				if(!isNaN(data)) {
					await WorkOrderProcessDetail.printPCCPending(this, data).then( async result => {
						if(result.result == "OK") {
							this.$bvToast.toast("Succeed Printing to ZPL Printer", {
								title: 'Print PCC Pending',
								variant: 'success',
								solid: true,
								autoHideDelay: 3000 // Optional: Mengatur durasi pesan
							});

							await this.getWorkOrderProcess(this.model.id);
						}
					});
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		printPccNg: async function(item) {
			try {

				if(item.printNgBy) {
					let message = `<b>PCC NG</b> sudah pernah di print pada tanggal <b>${moment(item.printNgDate).format("DD-MMM-YYYY")}</b> oleh <b>${item.printNgBy}</b>, apakah yakin untuk print ulang?`;
					if(!await this.showPopupWithMessage(message)) return;
				}

				let data = parseInt(item.id);
				if(!isNaN(data)) {
					await WorkOrderProcessDetail.printPCCNg(this, data).then(async result => {
						if(result.result == "OK") {
							this.$bvToast.toast("Succeed Printing to ZPL Printer", {
								title: 'Print PCC NG',
								variant: 'success',
								solid: true,
								autoHideDelay: 3000 // Optional: Mengatur durasi pesan
							});

							await this.getWorkOrderProcess(this.model.id);
						}
					});
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
			
		},
		printPdfCustom: async function(data) {
			try {
				let ids = [];
				if(data == "all") {
					this.workOrderProcessDetails.forEach(item => {
						let id = parseInt(item.id)
						if(!isNaN(id)) {
							ids.push(id);
						}
					});

					console.log("all", ids);
				} else {
					let id = parseInt(data.id);
					if(!isNaN(id)) {
						ids.push(id);
					}

					console.log("single", ids);
				}

				let result = await WorkOrderProcessDetail.printPdfCustom(this, ids);
				if(result) {
					console.log("result pdf", result)
					this.isShowPopUpPdf = true;
					this.pdfUrl = result.download;
				}
			} catch(error) {
				this.isShowPopUpPdf = false;
				this.pdfUrl = '';
			}
		},
		getWorkOrderProcess : async function(id) {
			this.isBusy = true;
			WorkOrderProcess.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.processTypeId != null) {
					promises.push(
						this.getProcessType(this.model.processTypeId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderProcess = true;
			this.filterWorkOrderProcess.id = this.modelId;
			WorkOrderProcess.downloadDataDetail(this, this.filterWorkOrderProcess).then(result => {
				this.isDownloadWorkOrderProcess = false;
			}).catch(error => { this.isDownloadWorkOrderProcess = false; })
		},
		getWorkOrderProcessDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderProcessDetail);
			if (this.modelId == null) return;
			filter.workOrderProcessId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByWorkOrderProcessDetail != null) {
				this.sortingByWorkOrderProcessDetail[this.sortByWorkOrderProcessDetail] = this.sortDescWorkOrderProcessDetail;
			}
			let currentPage = (this.currentWorkOrderProcessDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderProcessDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderProcessDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderProcessDetailPageSize = 0;
			// disable paging end
			WorkOrderProcessDetail.getList(this, filter, this.sortingByWorkOrderProcessDetail, currentPage , this.workOrderProcessDetailPageSize).then(result => {
				this.currentWorkOrderProcessDetailPage = currentPage + 1;
				this.workOrderProcessDetails = result.data;
				this.totalWorkOrderProcessDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.WorkOrderProcessNumber = input;
			}
			this.isWorkOrderProcessComboLoading = true;
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
				this.isWorkOrderProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfProcesss : async function(input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfProcessComboLoading = true;
			BillOfProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcesss = result.data
				}
				this.isBillOfProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLineCode(item) {
			if(item == undefined || item == null) {
				this.model.lineCodeId = null;
				this.model.lineCode = null;
			} else {
				this.model.lineCodeId = item.id;
				this.model.lineCode = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessType(item) {
			if(item == undefined || item == null) {
				this.model.processTypeId = null;
				this.model.processType = null;
			} else {
				this.model.processTypeId = item.id;
				this.model.processType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onProcessTypeChange : async function() {
			this.model.lineCodeId = null;
			this.model.lineCode = null;

			let item = this.model.processTypeId;
			let processTypeObj = this.processTypes.filter(function(processType){ return processType.id == item; });
			this.model.processType = processTypeObj.length > 0 ? processTypeObj[0] : null;
			this.getLineCodeByProcessType();
		},
		getLineCodeByProcessType : async function(input) {
			this.lineCodeState = false;
			this.$forceUpdate();

			let filter = new LineFilter();
			filter.processTypeId = this.model.processTypeId;
			if (input != undefined) {
				filter.code = input;
			}
			if (filter.processTypeId === undefined || filter.processTypeId === null || filter.processTypeId === '') {
				this.lineCodes = [];
			} else {
				Line.getList(this, filter, null, 0, 10)
					.then(result => {
						this.lineCodes = [];
						if (result != null) {
							this.lineCodes = result.data
						}
					})
					.catch(error => {
						this.lineCodes = [];
					});
			}

			this.lineCodeState = true;
			this.$forceUpdate();
		},

		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getProcessType : async function(id) {
			ProcessType.getData(this, id).then(result => {
				this.model.processType = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderProcessInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					WorkOrderProcess.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workorderprocessindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					WorkOrderProcess.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workorderprocessindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			return;
		},
		onHidden() {
			this.getWorkOrderProcesss();
		},
		addRowDataWorkOrderProcessDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				} else {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderProcessDetail(id) {
			this.workOrderProcessDetailId = id;
			this.isShowPopupWorkOrderProcessDetail = true; 
		},
		async deleteRowDataWorkOrderProcessDetail(id) {
			WorkOrderProcessDetail.deleteData(this, id).then(result => { this.getWorkOrderProcessDetails(); });
		},
		async resetDataWorkOrderProcessDetail() {
			this.workOrderProcessDetailId = "";
			this.isShowPopupWorkOrderProcessDetail = true;
		},
		async addDataWorkOrderProcessDetail() {
			WorkOrderProcessDetail.createData(this, { workOrderProcessId: this.modelId })
			.then(result => {
				this.getWorkOrderProcessDetails(true);
			})
		},
		async addFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.addFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});
		},
		async replaceFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.replaceFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});   
		},
		showPopupUploadWorkOrderProcessDetail() {
			if(this.workOrderProcessDetails != null && this.workOrderProcessDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap WorkOrderProcessDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadWorkOrderProcessDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadWorkOrderProcessDetail = true;
			}
		},
		uploadDataWorkOrderProcessDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
		},
		downloadWorkOrderProcessDetail(modalEvent) {
			this.isDownloadWorkOrderProcessDetail = true;
			this.filterWorkOrderProcessDetail.workOrderProcessId = this.modelId;
			WorkOrderProcessDetail.downloadDataDetail(this, this.filterWorkOrderProcessDetail).then(result => {
				this.isDownloadWorkOrderProcessDetail = false;
			}).catch(error => { this.isDownloadWorkOrderProcessDetail = false; })
		},
		saveInputWorkOrderProcessDetail(item) {
			return;
		},
		resetModal(modalType) {
			this.isShowPopUpPdf = false;
			this.isShowPopUpPdfList = false;
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
			this.isShowPopupWorkOrderProcessDetail = false; 
			if (modalType == 'WorkOrderProcessDetail') {
				this.getWorkOrderProcessDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowWorkOrderProcessDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterWorkOrderProcess = new WorkOrderProcessFilter();
		this.filterWorkOrderProcessDetail = new WorkOrderProcessDetailFilter();
		//this.getWorkOrderProcesss();
		//this.getParts();
		//this.getBillOfProcesss();
		//this.getMachines();
		//this.getDocumentStatuss();
		//this.getLines();
		//this.getProcessTypes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getWorkOrderProcess(id);
			} else {
				this.modelId = id;
				this.getWorkOrderProcess(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByWorkOrderProcessDetail : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		sortDescWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		currentWorkOrderProcessDetailPage: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		workOrderProcessDetailPageSize : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		filterWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			},
			deep: true,
		},
	},
}
</script>
